import { Base64 } from 'js-base64';
import { oz } from '@weft/utils';

export const Base64Schema = oz.string().refine(Base64.isValid);